"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBSecuredLoanPositive = function SvgBSecuredLoanPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M16.384 87.855a2.204 2.204 0 01-2.204-2.204V70.119a2.204 2.204 0 014.408 0v15.532a2.204 2.204 0 01-2.204 2.204z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M71.838 103.849a2.204 2.204 0 01-2.204-2.204v-26.45a2.204 2.204 0 114.408 0v26.45a2.204 2.204 0 01-2.204 2.204zM24.803 48.622a2.204 2.204 0 01-2.204-2.204v-7.883a2.204 2.204 0 114.408 0v7.883a2.204 2.204 0 01-2.204 2.204z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M24.803 37.998a8.589 8.589 0 01-5.877-2.292 2.204 2.204 0 113.02-3.21 4.269 4.269 0 002.894 1.094c2.145 0 3.894-1.47 3.894-3.291 0-1.955-2.05-3.137-4.078-3.306a10.513 10.513 0 01-2.872-.61c-3.233-1.308-5.246-4.019-5.246-7.075 0-4.29 3.725-7.744 8.302-7.744a8.619 8.619 0 015.804 2.204 2.204 2.204 0 11-2.939 3.27 4.217 4.217 0 00-2.843-1.051c-2.153 0-3.894 1.47-3.894 3.291 0 1.822 1.903 2.792 2.49 3.027a6.429 6.429 0 001.58.309c4.71.39 8.126 3.622 8.126 7.692-.059 4.225-3.776 7.692-8.36 7.692z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M24.796 49.592C11.102 49.592 0 38.49 0 24.796 0 11.102 11.102 0 24.796 0 26.013 0 27 .987 27 2.204v9.184a2.204 2.204 0 01-4.408 0V4.526C11.816 5.688 3.833 15.077 4.42 25.9c.587 10.822 9.538 19.293 20.376 19.284a20.388 20.388 0 009.485-38.44 2.205 2.205 0 012.057-3.9 24.796 24.796 0 01-11.542 46.748z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M64.954 70.391H9.36a2.204 2.204 0 010-4.408h55.594a2.204 2.204 0 010 4.408z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M64.954 70.391a2.204 2.204 0 01-1.682-.786 2.204 2.204 0 01.264-3.108L88.34 45.67a2.206 2.206 0 112.836 3.38L66.372 69.876c-.397.333-.9.515-1.418.514z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M127.425 122.297h-13.841a5.694 5.694 0 01-5.694-5.686V80.882H94.922V96.04a2.204 2.204 0 01-4.408 0V78.68c0-1.218.987-2.205 2.204-2.205h17.376c1.217 0 2.204.987 2.204 2.204v37.933a1.286 1.286 0 001.286 1.278h13.841a1.278 1.278 0 001.279-1.278V71.713c0-1.217.986-2.204 2.204-2.204h6.127L100.94 39.19H43.97a2.204 2.204 0 110-4.409h57.77c.518 0 1.02.182 1.417.515l39.24 32.958a3.203 3.203 0 01-2.057 5.665h-7.23v42.693a5.694 5.694 0 01-5.686 5.686z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M9.36 70.391a2.204 2.204 0 01-1.418-3.894l12.416-10.425a2.204 2.204 0 112.836 3.372L10.778 69.877c-.398.333-.9.515-1.418.514zM41.084 106.597H24.84a2.204 2.204 0 010-4.408h16.244a2.204 2.204 0 010 4.408z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M76.739 106.597H43.92a2.204 2.204 0 010-4.408h32.819a2.204 2.204 0 010 4.408z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M89.25 120.644a2.204 2.204 0 01-2.203-2.204v-7.156a4.687 4.687 0 00-4.688-4.687h-9.25a2.204 2.204 0 01-1.983-1.25l-4.122-8.544a15.972 15.972 0 00-14.32-9H32.328a2.204 2.204 0 010-4.408h20.358a20.417 20.417 0 0118.294 11.49l3.512 7.304h7.868a9.103 9.103 0 019.096 9.095v7.156a2.204 2.204 0 01-2.204 2.204z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M15.355 132.936c-6.405-.005-11.597-5.196-11.6-11.601V106.28a2.204 2.204 0 014.407 0v9.066h14.694c2.27 0 4.11 1.837 4.115 4.107v1.873c-.008 6.41-5.205 11.604-11.616 11.609zm-7.193-13.18v1.571a7.193 7.193 0 1014.386 0v-1.572H8.162z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M79.861 132.936a11.52 11.52 0 01-9.257-4.578 2.204 2.204 0 013.505-2.667 7.207 7.207 0 0012.938-4.356v-6.613a2.204 2.204 0 014.408 0v6.613c-.004 6.402-5.191 11.592-11.594 11.6z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M58.04 118.198a2.204 2.204 0 01-2.203-2.205v-4.709a4.687 4.687 0 00-4.688-4.687H41.011a4.129 4.129 0 01-4.122-4.122v-8.258a6.421 6.421 0 00-6.414-6.414h-6.414c-8.777.008-15.89 7.122-15.899 15.899v12.086a2.204 2.204 0 11-4.408 0v-12.086c.012-11.21 9.097-20.295 20.307-20.307h6.414c5.974.008 10.814 4.849 10.822 10.822v7.972h9.83a9.11 9.11 0 019.118 9.095v4.71a2.204 2.204 0 01-2.204 2.204z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M48.622 132.936c-6.412.004-11.615-5.19-11.623-11.601v-1.874a4.114 4.114 0 014.144-4.114h14.694v-1.543a2.204 2.204 0 114.408 0v1.543h32.473a2.204 2.204 0 110 4.408H60.245v1.572a11.608 11.608 0 01-11.623 11.609zm-7.215-13.18v1.571a7.207 7.207 0 0014.408 0v-1.572H41.407z",
    fill: "#1B7"
  })));
};

var _default = SvgBSecuredLoanPositive;
exports["default"] = _default;